import { Account } from '@/domain/usecases'
import { FeatureFlag } from '@/infra/feature-flag/feature-flag'
import { QueryClient } from 'react-query'
import BaseLoader, { DeferFunction } from '../base-loader'

export default abstract class InternalCompanyManagerBaseLoader extends BaseLoader {
  constructor(
    readonly account: Account.Model,
    readonly queryClient: QueryClient,
    readonly requiredFeatureFlag?: FeatureFlag.Key
  ) {
    super(account, undefined, queryClient)
  }

  async defer(deferRecords: DeferFunction) {
    const accountProfile = this.getAccount()
    if (Account.isInternalCompanyManager(accountProfile)) {
      return super.deferExec(deferRecords)
    } else {
      return this.notAllowedLoader.bind(this)()
    }
  }
}
